import React from "react";
import styles from "./Seat.module.scss";
import { ISeatProps } from "./types";

import { useSelector } from "react-redux";
import { rentSelector } from "../../redux/rent/selectors";

export const SeatItem = (props: ISeatProps) => {
  const { disabled = false, data, onClickFunc, activeRacketTime, selectedCount: propSelectedCount } = props;
  const { time, price, id, courtId, arenaId, date } = data;
  const { selectedSeats, selectedRackets } = useSelector(rentSelector);
  const [selectStatus, setSelectStatus] = React.useState<boolean>(false);
  const [selectedCount, setSelectedCount] = React.useState<number>(0);

  const isCourts = "startTimeCourt" in data;
  const keyName = isCourts ? `${id}-${courtId}-${arenaId}-${date}` : time;
  const count = !isCourts && "count" in data ? data.count : 1;

  React.useEffect(() => {
    function checkSelectedStatus() {
      if (isCourts) {
        const selectedSeat = selectedSeats[keyName];
        if (selectedSeat) {
          setSelectStatus(true);
        } else {
          setSelectStatus(false);
        }
      } else {
        const selectedRacket = selectedRackets[keyName];
        if (selectedRacket) {
          setSelectStatus(true);
          setSelectedCount(selectedRacket.count || 1);
        } else {
          setSelectStatus(false);
          setSelectedCount(0);
        }
      }
    }

    checkSelectedStatus();
  }, [selectedSeats, selectedRackets, keyName, date, id, isCourts]);

  const handleClick = () => {
    const state = isCourts ? selectedSeats : selectedRackets;

    if (!isCourts && selectStatus && activeRacketTime === time) {
      const cloneState = JSON.parse(JSON.stringify(state));
      delete cloneState[keyName];
      onClickFunc(cloneState, null);
      return;
    }

    if (isCourts && selectStatus) {
      const cloneState = JSON.parse(JSON.stringify(state));
      delete cloneState[keyName];
      onClickFunc(cloneState, undefined);
      return;
    }

    if (!selectStatus) {
      const cloneState = JSON.parse(JSON.stringify(state));
      cloneState[keyName] = {
        ...data,
        count: 1,
        originalPrice: (data as any).originalPrice || (data as any).price,
      };
      onClickFunc(cloneState, isCourts ? undefined : time);
    } else if (!isCourts) {
      onClickFunc(state, time);
    }
  };

  const displayCount = propSelectedCount !== undefined ? propSelectedCount : selectedCount;
  const isActive = !isCourts && activeRacketTime === time;
  const busyWithYou = isCourts && (data as any).busyWithYou;
  const busy = isCourts && (data as any).busy && !busyWithYou;

  // Получаем данные из selectedSeats, если место выбрано (для отображения скидки)
  const selectedSeat = isCourts && selectStatus ? selectedSeats[keyName] : null;
  const displayPrice = selectedSeat ? selectedSeat.price : price;
  const hasDiscount = selectedSeat?.hasDiscount || false;
  const originalPrice = selectedSeat?.originalPrice;

  return (
    <div className={styles.seat_wrapper}>
      {selectStatus && !isCourts && displayCount > 0 && (
        <div className={styles.count_bubble}>
          {displayCount}
        </div>
      )}
      <button
        disabled={disabled || busy || busyWithYou}
        className={`${styles.item} ${selectStatus ? styles.item_selected : ''} ${isActive ? styles.item_active : ''} ${busyWithYou ? styles.item_busy_with_you : ''} ${busy ? styles.item_busy : ''}`}
        onClick={handleClick}
      >
        <p className={styles.item_time}>
          {time}
        </p>
        <div className={styles.item_price}>
          {hasDiscount && originalPrice ? (
            <>
              <span className={styles.item_price_original}>{originalPrice} р/ч</span>
              <span className={styles.item_price_discount}>{displayPrice} р/ч</span>
            </>
          ) : (
            <span className={styles.item_price}>{displayPrice} р/ч</span>
          )}
        </div>
      </button>
    </div>
  );
};
